import * as React from 'react';

interface ISsrInitDataContext {
  ssr: boolean;
  location: {
    href: string,
  } | undefined;
  serverCompactMode: boolean | undefined;
  serverDismissedBanners: string;
  hasLoginToken: boolean | undefined;
  skipMaintenance: boolean | undefined;
  ga4id: string | undefined;
}

export const SsrInitDataContext = React.createContext<Partial<ISsrInitDataContext>>({});
